import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import React, { useEffect, useRef } from "react";
import { useMapInstanceHandle } from "../../hooks/google/maps/use-map-instance-handle";
import { MarkerFakeComponent, searchCenterMarkerImage } from "../DealerLocatorComponent/hooks/use-map-markers";

import { css } from "@emotion/react";
import { DealerWithCoordinatesT } from "../DealerLocatorComponent/queries/get-dealers-by-query";

export const MapElementWithPin: ReactTFC<{
  apiKey: string;
  coordinates: { latitude: number; longitude: number };
  name: string;
}> = props => {
  const mapElementRef = useRef<HTMLDivElement | null>(null);
  const mapInstanceHandle = useMapInstanceHandle(props.apiKey, mapElementRef, {
    panControl: false,
    zoomControl: false,
    draggable: false,
    gestureHandling: "none",
    draggableCursor: "default",
  });

  useEffect(() => {
    if (mapInstanceHandle && props.coordinates) {
      mapInstanceHandle.setCenter({
        lat: props.coordinates.latitude,
        lng: props.coordinates.longitude,
      });
      mapInstanceHandle.setZoom(12);
    }
  }, [mapInstanceHandle]);

  return (
    <React.Fragment>
      <MapElement ref={mapElementRef} coordinates={props.coordinates} />

      {mapInstanceHandle && (
        <MarkerFakeComponent
          dealer={{ isSelected: true, coordinates: props.coordinates, data: undefined, name: props.name }}
          icon={searchCenterMarkerImage(mapInstanceHandle)}
          mapInstanceHandle={mapInstanceHandle}
        />
      )}
    </React.Fragment>
  );
};

const MapElement = React.forwardRef<HTMLDivElement, { coordinates: DealerWithCoordinatesT["address"]["coordinates"] }>(
  (props, ref) => {
    return props.coordinates ? (
      <div
        ref={ref}
        css={css`
          width: 100%;
          height: 100%;
          object-fit: cover;
        `}
      />
    ) : null;
  },
);
